export enum NavItemTypeEnum {
  users = 'Users',
  chats = 'Chats',
  createChat = 'Create Chat'
}
